import React from 'react'
import { Button, Confirm, useBooleanState, Text } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { Fragment, type FunctionComponent } from 'react'
import { useDashMessages } from 'intl/intl.hooks'
import LoadingDots from 'legacy/components/LoadingDots'
import { ErrorMessage } from 'gin-and-tonic/common/error-message/ErrorMessage'
import { type EnterpriseApolloError } from 'legacy/apollo/errors'

interface Props {
  isLoading: boolean
  submitError: EnterpriseApolloError
  onCancel: () => void
}

const actionWrapper = css({
  display: 'flex',
  justifyContent: 'flex-end',
})

const statusWrapper = css({
  display: 'flex',
  justifyContent: 'center',
})

export const MerchandisingFormActions: FunctionComponent<Props> = ({
  isLoading,
  submitError,
  onCancel,
}) => {
  const { discard, save, error, confirmTitle, confirmBody } = useDashMessages({
    discard: 'forms.discard',
    save: 'forms.save',
    confirmTitle: 'merchandising.hero-banners.form.discard.confirm.title',
    confirmBody: 'merchandising.hero-banners.form.discard.confirm.body',
    error: 'common.error',
  })

  const [confirmOpen, showConfirm, hideConfirm] = useBooleanState(false)

  return (
    <Fragment>
      <div css={actionWrapper}>
        <Button onClick={showConfirm} variant="detrimental">
          {discard}
        </Button>
        <Button type="submit" variant="primary">
          {save}
        </Button>
      </div>

      <div css={statusWrapper}>
        {isLoading && <LoadingDots />}
        {submitError && <ErrorMessage>{error}</ErrorMessage>}
      </div>

      <Confirm
        headerContent={<Text size="large">{confirmTitle}</Text>}
        bodyContent={<Text>{confirmBody}</Text>}
        isOpen={confirmOpen}
        onCancel={hideConfirm}
        onConfirm={onCancel}
      />
    </Fragment>
  )
}
